import React from 'react'
import ForcedNotificationWrapper from 'widgets/forced-notifications/partials/ForcedNotificationWrapper'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'
import { Link } from '@morningtrain/react-navigation'

export default function ForcedContracts ({ contracts }) {
  return (
    <ForcedNotificationWrapper>
      <UI.CardHeader>
        <UI.PrimaryHeading>
          <Translation name='tablet.signing.new_contracts' />
        </UI.PrimaryHeading>
      </UI.CardHeader>
      <div className='w-full flex flex-col'>
        {contracts.map(contract => {
          return (
              <div>
                  We have sent an email to <b>{contract.email}</b> with signing link.<br />
                  If you are not logged please go to "HR" -> "My contracts" -> Click "Sign contract"
              </div>
          )
        })}
      </div>
    </ForcedNotificationWrapper>
  )
}
